import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "mb-2 ms-2",
  style: {"color":"#ff8800","font-size":"18px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-triangle-exclamation fa-lg me-1",
  style: {"color":"#ff8800"}
}, null, -1)
const _hoisted_3 = { class: "input-group mb-3" }
const _hoisted_4 = {
  class: "input-group-text",
  for: "inputGroupSelect01"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs-4 text-end",
  style: {"color":"#d9534f"}
}, [
  /*#__PURE__*/_createTextVNode(" 如要新增 "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "貨幣"),
  /*#__PURE__*/_createTextVNode(" 請通知 IT Department ")
], -1)
const _hoisted_14 = { class: "d-flex gap-2 mb-3" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "card-header p-4" }
const _hoisted_18 = { class: "d-flex align-items-end" }
const _hoisted_19 = {
  class: "fs-1 fw-bold",
  style: {"color":"#5cb85c"}
}
const _hoisted_20 = {
  class: "fs-4 ms-3 pb-1 fw-bold",
  style: {"color":"#6c757d"}
}
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { class: "fw-bold" }, "Deposit 卖出价", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", { class: "fw-bold" }, "Withdraw 买入价", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", { class: "fw-bold" }, "Adjust 调整 %", -1)
const _hoisted_26 = { class: "fw-bold text-center" }
const _hoisted_27 = { class: "fw-bold text-center" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { style: {"font-size":"12px","color":"rgba(113, 113, 113, 1)"} }
const _hoisted_34 = { class: "text-center" }

import moment from "moment";

import { ref, onMounted } from "vue";
import { CurrencyTypes } from "@/core/types/CurrencyTypes";
import LoadingRing from "@/components/LoadingRing.vue";
import PaymentService from "../services/PaymentService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import NoDataBox from "@/components/NoDataBox.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeRate',
  setup(__props) {

const t = useI18n().t;
const isSubmitting = ref(false);
const selectedCurrency = ref("");
const newData = ref({} as any);
const fromCurrencies = ref<any>([]);
const exchangeRates = ref([] as any);
const rateSymbols = ref({} as any);
const criteria = ref({
  size: 5,
});

const getFromCurrencies = async (data) => {
  try {
    fromCurrencies.value = data.map((item) => {
      return {
        fromCurrencyId: item.fromCurrencyId,
        fromCurrencyCode: item.fromCurrencyCode,
      };
    });
    // Remove duplicates
    fromCurrencies.value = Array.from(
      new Set(fromCurrencies.value.map((item) => item.fromCurrencyCode))
    ).map((code) => {
      return fromCurrencies.value.find(
        (item) => item.fromCurrencyCode === code
      );
    });
    console.log(fromCurrencies.value);
  } catch (error) {
    console.error("Error fetching from currencies:", error);
  }
};

const fetchData = async (_currency?: any) => {
  var currency = _currency || null;

  if (currency) {
    currency = currency.fromCurrencyId || currency;
  }
  selectedCurrency.value = currency || "";
  rateSymbols.value = {};
  const res = await PaymentService.getExchangeRate({
    page: 1,
    size: 100,
    numPages: 1,
    fromCurrencyId: currency,
  });

  exchangeRates.value = res.data;
  res.data.forEach((item) => {
    if (rateSymbols.value[item.name] == undefined)
      rateSymbols.value[item.name] = {};
    rateSymbols.value[item.name].id = item.id;
    rateSymbols.value[item.name].symbol = item.name;
    rateSymbols.value[item.name].from = item.fromCurrencyId;
    rateSymbols.value[item.name].to = item.toCurrencyId;
    rateSymbols.value[item.name].isLoading = true;
    rateSymbols.value[item.name].error = "";
    rateSymbols.value[item.name].data = [];
  });
  for (const key of Object.keys(rateSymbols.value)) {
    getRate(rateSymbols.value[key]);
  }
};

onMounted(async () => {
  await fetchData();
  await getFromCurrencies(exchangeRates.value);
});

const getRate = async (item: any) => {
  item.isLoading = true;
  item.data = [];

  try {
    var data = [] as any;

    data = await PaymentService.getExchangeRateHistory(item.id, criteria.value);
    const dataLength = ref(
      criteria.value.size < data.length ? criteria.value.size : data.length
    );
    console.log(data[0]);
    if (data.length == 0) {
      item.isLoading = false;
    } else {
      for (let i = 0; i < dataLength.value; i++) {
        item.data.push({
          deposit: data[i]?.changes.currentValues.SellingRate ?? "--",
          markupDeposit:
            data[i]?.id == 2
              ? Math.ceil(
                  data[i]?.changes.currentValues.SellingRate *
                    (1 + data[i]?.changes.currentValues.AdjustRate / 100) *
                    1000
                ) / 1000
              : Math.ceil(
                  data[i]?.changes.currentValues.SellingRate *
                    (1 + data[i]?.changes.currentValues.AdjustRate / 100) *
                    100000
                ) / 100000,
          withdraw: data[i]?.changes.currentValues.BuyingRate ?? "--",
          markupWithdraw:
            data[i]?.id == 2
              ? Math.floor(
                  data[i]?.changes.currentValues.BuyingRate *
                    (1 - data[i]?.changes.currentValues.AdjustRate / 100) *
                    1000
                ) / 1000
              : Math.floor(
                  data[i]?.changes.currentValues.BuyingRate *
                    (1 - data[i]?.changes.currentValues.AdjustRate / 100) *
                    100000
                ) / 100000,
          adjust: data[i]?.changes.currentValues.AdjustRate,

          updatedOn: data[i]?.createdOn,
          staff: data[i]?.operatorName,
        });
      }
    }
  } catch (error) {
    item.error = error;
  }
  item.isLoading = false;
};

const create = async () => {
  if (
    Object.keys(newData.value).length == 0 ||
    newData.value.symbol == "" ||
    newData.value.symbol == undefined
  ) {
    return;
  }

  const sellingRate = ref(newData.value.deposit);
  const buyingRate = ref(newData.value.withdraw);

  if (sellingRate.value == undefined || sellingRate.value == 0) {
    sellingRate.value =
      rateSymbols.value[newData.value.symbol].data[0]?.deposit ?? 0;
  }
  if (buyingRate.value == undefined || buyingRate.value == 0) {
    buyingRate.value =
      rateSymbols.value[newData.value.symbol].data[0]?.withdraw ?? 0;
  }

  isSubmitting.value = true;

  try {
    await PaymentService.putExchangeRate(
      rateSymbols.value[newData.value.symbol].id,
      {
        id: rateSymbols.value[newData.value.symbol].id,
        name: rateSymbols.value[newData.value.symbol].symbol,
        sellingRate: sellingRate.value,
        buyingRate: buyingRate.value,
        adjustRate: newData.value.adjust == "" ? 0 : newData.value.adjust,
      }
    );

    isSubmitting.value = false;

    MsgPrompt.success("Exchange Rate Update Success").then(() => {
      getRate(rateSymbols.value[newData.value.symbol]);
    });
  } catch (error) {
    console.log(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("tip.rateUpdate")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("action.createNewRate")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control",
        name: "depositRate",
        placeholder: _unref(t)('fields.depositRate'),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newData.value.deposit) = $event))
      }, null, 8, _hoisted_5), [
        [_vModelText, newData.value.deposit]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control",
        name: "depositRate",
        placeholder: _unref(t)('fields.withdrawalRate'),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newData.value.withdraw) = $event))
      }, null, 8, _hoisted_6), [
        [_vModelText, newData.value.withdraw]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control",
        name: "adjujstRate",
        placeholder: _unref(t)('fields.markup'),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newData.value.adjust) = $event))
      }, null, 8, _hoisted_7), [
        [_vModelText, newData.value.adjust]
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "form-select",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newData.value.symbol) = $event))
      }, [
        _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t("action.selectSymbols")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rateSymbols.value, (item, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: index,
            value: item.symbol
          }, _toDisplayString(item.symbol), 9, _hoisted_9))
        }), 128))
      ], 512), [
        [_vModelSelect, newData.value.symbol]
      ]),
      _createElementVNode("button", {
        class: "btn btn-secondary",
        type: "button",
        onClick: create
      }, [
        (isSubmitting.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.$t("action.waiting")) + " ", 1),
              _hoisted_11
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("action.create")), 1))
      ])
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_el_button, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (fetchData())),
        type: selectedCurrency.value === '' ? 'warning' : 'default'
      }, {
        default: _withCtx(() => [
          _createTextVNode("All")
        ]),
        _: 1
      }, 8, ["type"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fromCurrencies.value, (item) => {
        return (_openBlock(), _createBlock(_component_el_button, {
          key: item,
          onClick: ($event: any) => (fetchData(item)),
          type: selectedCurrency.value === item.fromCurrencyId ? 'warning' : 'default'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.fromCurrencyCode), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "type"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rateSymbols.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-6 mb-4",
          key: index
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(item.symbol), 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("title.exchangeRate")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("table", _hoisted_22, [
                _createElementVNode("thead", null, [
                  _hoisted_23,
                  _hoisted_24,
                  _hoisted_25,
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t("fields.operator")), 1)
                ]),
                (item.isLoading)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_28, [
                      _createVNode(LoadingRing)
                    ]))
                  : (!item.isLoading && item.data.length === 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_29, [
                        _createVNode(NoDataBox)
                      ]))
                    : (item.error)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_30, _toDisplayString(item.error), 1))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_31, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (rate, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(rate.markupDeposit) + " (" + _toDisplayString(rate.deposit) + ")", 1),
                              _createElementVNode("td", null, _toDisplayString(rate.markupWithdraw) + " (" + _toDisplayString(rate.withdraw) + ")", 1),
                              _createElementVNode("td", null, _toDisplayString(rate.adjust), 1),
                              _createElementVNode("td", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(moment)(rate.updatedOn).format("M-D H:m:s")), 1)
                              ]),
                              _createElementVNode("td", _hoisted_34, _toDisplayString(rate.staff), 1)
                            ]))
                          }), 128))
                        ]))
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ], 64))
}
}

})